module.exports = __webpack_public_path__ + "img/error.3795c26d.png";